import React, { useEffect, useState } from 'react';
import { trackEvent, GA_EVENTS } from '../../utils/analytics';
import { shouldAnimate } from '../../utils/motion';
import './WhatsAppButton.css';

const PHONE = '529903888082';
const MESSAGE = 'Hola, quiero un diagnóstico de costos cloud o automatización de reportes';
const TIP_KEY = 'creditoolsmx:wa-tip-shown';
const TIP_SCROLL_RATIO = 0.35;
const TIP_DURATION = 5000;

// Shows "¿Dudas? Escríbenos" once per session, after the visitor reads a third of the page.
function useScrollTip() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!shouldAnimate()) return undefined;
        try {
            if (window.sessionStorage.getItem(TIP_KEY)) return undefined;
        } catch (error) {
            // Storage unavailable: the tip can still show once on this page.
        }

        let timer = 0;
        const onScroll = () => {
            const max = document.documentElement.scrollHeight - window.innerHeight;
            if (max <= 0 || window.scrollY / max < TIP_SCROLL_RATIO) return;
            window.removeEventListener('scroll', onScroll);
            try {
                window.sessionStorage.setItem(TIP_KEY, '1');
            } catch (error) {
                // Ignore storage errors.
            }
            setVisible(true);
            timer = window.setTimeout(() => setVisible(false), TIP_DURATION);
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', onScroll);
            window.clearTimeout(timer);
        };
    }, []);

    return visible;
}

export default function WhatsAppButton() {
    const url = `https://wa.me/${PHONE}?text=${encodeURIComponent(MESSAGE)}`;
    const tipVisible = useScrollTip();

    const handleClick = () => {
        trackEvent(GA_EVENTS.CLICK_WHATSAPP, { source: 'floating_button' });
    };

    return (
        <a
            href={url}
            target="_blank"
            rel="noreferrer"
            className={`wa-float ${tipVisible ? 'wa-float--tip' : ''}`}
            onClick={handleClick}
            aria-label="Contactar por WhatsApp"
            id="whatsapp-float"
        >
            <svg viewBox="0 0 32 32" width="28" height="28" fill="#FFFFFF">
                <path d="M16.004 0C7.165 0 .002 7.161.002 15.997c0 2.819.737 5.571 2.137 7.997L.01 32l8.21-2.098a16.02 16.02 0 007.784 1.986h.006C24.842 31.888 32 24.727 32 15.997 32 7.161 24.842 0 16.004 0zm0 29.29a13.36 13.36 0 01-6.82-1.87l-.49-.29-5.07 1.33 1.35-4.94-.318-.505A13.31 13.31 0 012.6 15.997c0-7.39 6.014-13.4 13.404-13.4 7.39 0 13.398 6.01 13.398 13.4 0 7.39-6.008 13.293-13.398 13.293zm7.35-10.035c-.402-.202-2.383-1.176-2.752-1.31-.37-.135-.638-.202-.907.202-.268.403-1.04 1.31-1.275 1.578-.236.27-.47.303-.873.102-.402-.202-1.698-.626-3.234-1.996-1.196-1.066-2.003-2.383-2.238-2.785-.236-.403-.025-.62.177-.82.182-.18.403-.47.605-.706.202-.236.269-.403.403-.672.134-.268.067-.504-.034-.706-.1-.202-.907-2.184-1.242-2.99-.327-.786-.66-.68-.907-.692l-.773-.013c-.268 0-.706.1-1.075.504-.37.403-1.41 1.377-1.41 3.36 0 1.982 1.443 3.897 1.644 4.165.202.269 2.84 4.333 6.88 6.075.961.415 1.712.662 2.297.848.965.307 1.843.264 2.537.16.774-.116 2.383-.974 2.72-1.914.336-.94.336-1.746.235-1.914-.1-.168-.37-.269-.773-.47z"/>
            </svg>
            <span className="wa-float-text">WhatsApp</span>
            <span className="wa-float-tip" aria-hidden="true">¿Dudas? Escríbenos</span>
        </a>
    );
}
